import { FCInquiries } from './FCInquiries';
import { CSInquiries } from './CSInquiries';
import { FGTypography } from '@fg/design-system';
import { HeaderFooter } from './HeaderFooter';

type Props = {
  customProps: {
    appCode: string;
    logoType: string;
    helpPage: string;
  };
};
export const Inquiries = ({ customProps }: Props) => {
  const { appCode, logoType, helpPage } = customProps;
  const showDisclaimerFooter = appCode === 'frp';
  return (
    <>
      <HeaderFooter appCode={appCode} logoType={logoType} showDisclaimerFooter={showDisclaimerFooter}>
        <div>
          <div
            className="fg-pd--x5 fg-inquiries__content-wrapper"
            style={{
              margin: '30px auto',
            }}
          >
            <FGTypography tag="h1" style="headline1" className="fg-ta--c">
              How can we help you?
            </FGTypography>
            {helpPage === 'connect' && <FCInquiries />}
            {helpPage === 'credit-sights' && <CSInquiries />}
          </div>
        </div>
      </HeaderFooter>
    </>
  );
};
